import React, { useState } from "react";
import { Card, CardHeader, CardBody, Button, Alert } from "reactstrap";
import ChangeEncryptionPasswordModal from "./ChangeEncryptionPasswordModal";

const PasswordResetPage = () => {
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleChangeClick = () => {
    setShowChangeModal(true);
  };

  const handleChangeSuccess = (successMessage) => {
    setMessage(successMessage);
    setMessageType("success");
    setShowChangeModal(false);
  };

  const handleChangeClose = () => {
    setShowChangeModal(false);
  };

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <Card>
            <CardHeader>
              <h4 className="mb-0">
                <i className="fas fa-key me-2"></i>
                Change Encryption Password
              </h4>
            </CardHeader>
            <CardBody>
              {message && (
                <Alert color={messageType} className="mb-4">
                  {message}
                </Alert>
              )}

              <div className="mb-4">
                <h5>Encryption Password Management</h5>
                <p className="text-muted">
                  Change your encryption password for Enhanced or Maximum
                  security levels. Standard security uses service-manageable
                  encryption keys.
                </p>

                <Alert color="info" className="mb-3">
                  <strong>Security Level Requirements:</strong>
                  <ul className="mb-0 mt-2">
                    <li>
                      <strong>Standard Security:</strong> Uses
                      service-recoverable encryption - no user passwords
                      required
                    </li>
                    <li>
                      <strong>Enhanced Security:</strong> Current password or
                      recovery key required
                    </li>
                    <li>
                      <strong>Maximum Security:</strong> Current password
                      required (no recovery options)
                    </li>
                  </ul>
                </Alert>

                <Button
                  color="primary"
                  onClick={handleChangeClick}
                  className="me-2"
                >
                  <i className="fas fa-key me-2"></i>
                  Change Encryption Password
                </Button>
              </div>

              <hr />

              <div className="mb-4">
                <h5>How This Works</h5>
                <div className="row">
                  <div className="col-md-4">
                    <div className="border rounded p-3 h-100">
                      <h6 className="text-primary">
                        <i className="fas fa-info-circle me-1"></i>
                        Standard Security
                      </h6>
                      <small className="text-muted">
                        Uses service-recoverable encryption keys. No user
                        encryption passwords to change. Upgrade to Enhanced for
                        user-controlled password protection.
                      </small>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="border rounded p-3 h-100">
                      <h6 className="text-warning">
                        <i className="fas fa-key me-1"></i>
                        Enhanced Security
                      </h6>
                      <small className="text-muted">
                        Current password or recovery key required. All data will
                        be re-encrypted with the new password.
                      </small>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="border rounded p-3 h-100">
                      <h6 className="text-danger">
                        <i className="fas fa-shield-alt me-1"></i>
                        Maximum Security
                      </h6>
                      <small className="text-muted">
                        Current password required. Zero-knowledge security means
                        no recovery options are available.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>

      <ChangeEncryptionPasswordModal
        show={showChangeModal}
        onClose={handleChangeClose}
        onSuccess={handleChangeSuccess}
      />
    </div>
  );
};

export default PasswordResetPage;
